export interface IMenuCategoryDto {
  id: number;
  name: string;
  order: number;
  menuLevel: number;
  subCategory: IMenuSubCategoryDto[];
}

export interface IMenuSubCategoryDto {
  id: number;
  name: string;
  order: number;
  menuItems: IMenuItemsDto[];
}

export interface IMenuItemsDto {
  id: number;
  itemName: string;
  order: number;
  description: string;
  unitPrice: number;
  basePrice: number;
  isImage: boolean;
  imagePath: string;
  isBreakfast: boolean;
  isLunch: boolean;
  isDinner: boolean;
  mon: string;
  tue: string;
  wed: string;
  thu: string;
  fri: string;
  sat: string;
  sun: string;
  isActive: boolean;
  isTaxable: boolean;
  menuItemTags: IMenuImageTagDto[];
  menuAddons: IMenuAddonDto[];
}

export interface IMenuAddonDto {
  id: number;
  order: number;
  addonSelectionType: number;
  minChoice: number;
  maxChoice: number;
  groupName: string;
  menuAddonItems: IMenuAddonItemsDto[];
}

export interface IMenuAddonItemsDto {
  id: number;
  name: string;
  order: number;
  basePrice: number;
  price: number;
  isSelected?: boolean;
  isMultiple: boolean;
  quantity: number;
  groupName: string;
}

export interface ICartItem {
  tempId: string;
  categoryId: number;
  subCategoryId: number;
  menuItemId: number;
  name: string;
  quantity: number;
  price: number;
  note: string;
  isTaxable: boolean;
  menuAddonItems: IMenuAddonItemsDto[];
}

export interface ICartMenuItems extends IMenuItemsDto {
  quanity: number;
  note: string;
}

export class CartItem implements ICartItem {
  tempId: string;
  categoryId: number;
  subCategoryId: number;
  menuItemId: number;
  name: string;
  quantity: number;
  price: number;
  note: string;
  isTaxable: boolean;
  menuAddonItems: IMenuAddonItemsDto[];

  constructor(json: ICartItem) {
    Object.assign(this, json);
  }
}

export interface IMenuItemFilter {
  name: string;
  value: number;
  categoryId?: number;
  subCategoryId?: number;
}

export interface IScheduleMenuDto {
  id: number;
  isScheduleOrder: boolean;
  scheduledOrderDate: string;
  scheduledOrderTime: string;
  isOffline: boolean;
  type: number;
}

export interface IMenuImageTagDto {
  id: number;
  tagId: number;
  name: string;
  identifier: string;
  isActive: boolean;
  isAttachment: boolean;
  attachment: string;
  image: string;
  isSelected: boolean;
}
